export enum SubmittedDocumentType {
  Covid19Document = 'Covid19Document',
}
